"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = memoryStorage;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/createClass"));

var MemoryStorage = /*#__PURE__*/function () {
  function MemoryStorage() {
    (0, _classCallCheck2["default"])(this, MemoryStorage);
    this.storage = {};
  }

  (0, _createClass2["default"])(MemoryStorage, [{
    key: "setItem",
    value: function setItem(key, value) {
      this.storage[key] = value;
    }
  }, {
    key: "getItem",
    value: function getItem(key) {
      return this.storage[key];
    }
  }, {
    key: "removeItem",
    value: function removeItem(keyName) {
      delete this.storage[keyName];
    }
  }, {
    key: "clear",
    value: function clear() {
      this.storage = {};
    }
  }]);
  return MemoryStorage;
}();

var storage = null;

function memoryStorage() {
  if (!storage) {
    storage = new MemoryStorage();
  }

  return storage;
}